module.exports = __webpack_public_path__ + "img/1-3-1.4cd1f35c.png";